import { tasksSlice } from './slice';

export const {
  empty,
  add,
  loadingProjectTasks,
  loadedProjectTasks,
  loadedAllTasks,
  creating,
  created,
  failed,
  updating,
  updated,
  revert,
  deleting,
  deleted,
  restored,
} = tasksSlice.actions;
